import PropTypes from 'prop-types'
import PageCount from './PageCount'
import { ROLES } from '../../config/user'
import ChevronUp from 'mdi-material-ui/ChevronUp'
import { useSession } from '../../context/SessionContext'
import ChevronDown from 'mdi-material-ui/ChevronDown'
import { Button, Typography } from '@material-ui/core'
// import Button from './Button'

/**
 * Custom `PreviewBarLeft` component declaration.
 * This component integrates PageCount and has ChevronUp and ChevronDown components of material-ui
 * @param {Number} totalPages 
 * @param {Number} currentPage 
 * @param {Function} onPageUp 
 * @param {Function} onPageDown
 * @param {Boolean} hidden
 * @return PreviewBarLeft
 */
const PreviewBarLeft = (props: any) => {

  const { user } = useSession()

  return (
    <div className="preview-bar-left">

      {props.hidden === true && user?.role === ROLES.USER ? 
        <Typography
          gutterBottom
          variant="body2"
          component="p"
          style={{ fontSize: '0.9rem', fontWeight: 'normal', textAlign: 'center', marginTop: '0.5vh'}}
        >
          Los fragmentos sombreados del documento desaparecerán tan pronto realices el pago del mismo.
        </Typography>
      : 
      <></>}

      {/* Page to go up means going back. */}
      <Button onClick={props.onPageUp} disabled={props.currentPage === 0}>
        <ChevronUp />
      </Button>

      {/* Page to go down means going next. */}
      <Button
        onClick={props.onPageDown}
        disabled={props.currentPage + 1 === props.totalPages}
      >
        <ChevronDown />
      </Button>

      <PageCount current={props.currentPage} total={props.totalPages} />
    </div>
  )
}

PreviewBarLeft.propTypes = {
  totalPages: PropTypes.number.isRequired,
  currentPage: PropTypes.number.isRequired,
  onPageUp: PropTypes.func.isRequired,
  onPageDown: PropTypes.func.isRequired,
  hidden: PropTypes.bool,
}

export default PreviewBarLeft